import { Box, IconButton, Stack, Typography } from "@mui/material";
import CopyIcon from "assets/svg/CopyIcon";
import DownloadIcon from "assets/svg/DownloadIcon";
import EllipseIcon from "assets/svg/EllipseIcon";
import QueryIcon from "assets/svg/QueryIcon";
import ReceiveToMobileIcon from "assets/svg/ReceiveToMobileIcon";
import ShareIcon from "assets/svg/ShareIcon";
import PrimaryButton from "components/PrimaryButton/PrimaryButton";
import SecondaryButton from "components/SecondaryButton/SecondaryButton";
import { commonStyle } from "pages/Dashboard/common.styles";
import { useRef } from "react";
import { QRCode } from "react-qrcode-logo";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { RootState } from "reduxStore/store";
import theme, { responsiveFontSize } from "themes/Theme";
import logoImg from "assets/images/logo.webp";

const ReceiveCoin = () => {
  const walletData = useSelector((state: RootState) => state.wallet);
  const qrRef = useRef<any>(null);

  const handleDownloadQR = () => {
    if (qrRef.current) {
      const download = qrRef.current.download();
      console.log("Download QR: ", download);
    }
  };

  const handleCopyToClipboard = async () => {
    if (!walletData?.wallet?.data?.address) return;
    try {
      await navigator.clipboard.writeText(walletData?.wallet?.data?.address);
      toast.info("Address copied to clipboard successfully");
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <Box
      sx={{
        ...commonStyle.cardStyle,
        p: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Stack direction={"row"} alignItems={"center"} gap={1}>
        <ReceiveToMobileIcon />
        <Typography
          sx={{
            ...commonStyle.cardTitleText,
            fontSize: { xs: 18, sm: 22, md: 18 },
          }}
        >
          Receive Coin
        </Typography>
      </Stack>

      <Box sx={styles.flexCenter} mt={{ xs: 1, sm: 2 }}>
        <Typography sx={styles.myQRText}>My QR Code</Typography>

        <center>
          <QRCode
            ref={qrRef}
            size={
              typeof window !== "undefined" && window.innerWidth < 400
                ? 120
                : 170
            }
            ecLevel="Q"
            value={walletData?.wallet?.data?.address || ""}
            logoPadding={8}
            logoHeight={32}
            logoWidth={32}
            logoImage={logoImg}
            qrStyle="dots"
            logoPaddingStyle="circle"
          />
          <Box sx={styles.hashTransactionStyle}>
            <Typography sx={styles.hashTextStyle}>
              {walletData?.wallet?.data?.address}
            </Typography>
            <IconButton onClick={handleCopyToClipboard} size="small">
              <CopyIcon />
            </IconButton>
          </Box>
        </center>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems="center"
          justifyContent="center"
          gap={1}
          mt={2}
        >
          <PrimaryButton
            rightIcon={<DownloadIcon />}
            title="Download QR Code"
            onClick={handleDownloadQR}
            viewStyle={{
              borderRadius: "999px",
              padding: { xs: "8px 16px", sm: "10px 24px" },
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
              color: "#fff",
              fontWeight: 600,
              fontSize: responsiveFontSize(14),
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
              display: "flex",
              alignItems: "center",
              gap: 1,
              transition: "all 0.2s ease-in-out",
              width: { xs: "100%", sm: "auto" },
              justifyContent: "center",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.2)",
                background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
              },
            }}
          />
        </Stack>
      </Box>
    </Box>
  );
};
export default ReceiveCoin;
const styles = {
  flexCenter: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  myQRText: {
    fontSize: { xs: responsiveFontSize(15), sm: responsiveFontSize(18) },
    color: theme.palette.text.primary,
    textAlign: "center",
    mb: { xs: 1, sm: 2 },
  },
  hashTransactionStyle: {
    border: "0.75px solid rgba(232, 232, 232, 1)",
    marginTop: 1,
    padding: { xs: "4px 6px", sm: "5px 10px" },
    borderRadius: "8px",
    display: "flex",
    width: "fit-content",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: { xs: "90vw", sm: "none" },
    overflowX: "auto",
  },
  hashTextStyle: {
    fontSize: { xs: responsiveFontSize(10), sm: responsiveFontSize(11.84) },
    color: theme.palette.text.primary,
    fontWeight: 400,
    marginRight: 1,
    wordBreak: "break-all",
  },
};
